var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendingOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assending"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.9589 12.2025L14.9589 4.16675M14.9589 4.16675L17.881 7.08882M14.9589 4.16675L12.0368 7.08883M1.80957 5.77388H8.23814M1.80957 10.5957H11.4524M1.80957 15.4167H14.6667",
    stroke: "#374151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingOrderIcon);
export default __webpack_public_path__ + "static/media/ascending-order-icon.76eea80ef028b41882ec1f375023d6b2.svg";
export { ForwardRef as ReactComponent };